/**
 * Cuentas corrientes ahora es la vista «Me deben» de Clientes.
 *
 * La ruta queda para no romper lo que la enlazaba: marcadores, historial del
 * navegador y el viejo `?cliente=ID`, que abria el cobro de ese cliente y ahora
 * abre su ficha con el cobro encima.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cuentas-corrientes")({
  validateSearch: (busqueda: Record<string, unknown>): { cliente?: number } => {
    const cliente = Number(busqueda.cliente);
    return Number.isInteger(cliente) && cliente > 0 ? { cliente } : {};
  },
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/clientes",
      search: search.cliente ? { id: search.cliente, cobrar: 1 } : {},
      replace: true,
    });
  },
});
